import {
  EuerDeclarationSubformType,
  EuerDeclarationSubformCalculationMethod,
} from "./enums";
import {
  getCalculator,
  EuerDeclarationSubformInputs,
  EuerDeclarationSubformCalculationResults,
} from "./calculators";

export const calculateSubformResults = (
  type: EuerDeclarationSubformType,
  calculationMethod: EuerDeclarationSubformCalculationMethod,
  inputs: EuerDeclarationSubformInputs,
  declarationYear?: number
): EuerDeclarationSubformCalculationResults => {
  const calculate = getCalculator(type, calculationMethod);
  if (!calculate) {
    throw new Error(
      `Couldn't find calculator for type "${type}" and calculationMethod "${calculationMethod}"`
    );
  }
  return calculate(inputs, declarationYear);
};
